module.exports = new __parcel__URL__("neon_gold_icon_large.a4fe33c5.png").toString();